import { StyleSheet, Dimensions } from 'react-native';

const { width } = Dimensions.get('window');

export default StyleSheet.create({
  occurrenceContainer: {
    marginBottom: 20,
  },
  containerStyle: {
    marginTop: 17,
  },
  listStyle: {
    flexGrow: 0,
    marginTop: 12,
    marginBottom: 19.4,
  },
  optionStyle: theme => {
    return {
      width: (width - 48) / 3,
      height: 50,
      marginRight: 8,
      backgroundColor: theme.colors.backgroundColorFour,
    };
  },
  occurrenceOptionsContainer: {
    paddingLeft: 16,
    paddingRight: 8,
  },
  contentContainerStyle: {
    paddingLeft: 14,
    paddingRight: 14,
  },
  titleStyle: theme => ({
    color: theme.colors.text.primary,
    fontSize: 19,
    marginTop: 4,
  }),
  activeTitleStyle: theme => ({
    color: theme.colors.text.primary,
    fontSize: 19,
  }),
  description: {
    marginTop: 10,
    minHeight: 56,
  },
});
